import {
  Button, InputAdornment, TextField, Typography,
} from '@mui/material';
import Overlay from 'components/Overlay';
import { CateringContext } from 'constants/contexts';
import useIsMobile from 'hooks/useIsMobile';
import React, { useContext, useEffect, useState } from 'react';

function HeadcountOverlay({ open, onClose }) {
  const catering = useContext(CateringContext);
  const [headcount, setHeadcount] = useState();
  const isDisabled = !Number(headcount) && !catering.headcount;
  const isMobile = useIsMobile();

  useEffect(() => {
    setHeadcount();
  }, [open]);

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (isDisabled) {
      return;
    }
    if (headcount) {
      catering.set({ headcount: Math.max(Number(headcount), 1) });
    }
    onClose();
  };

  return (
    <Overlay open={open} onClose={onClose}>
      <Overlay.Header>
        Headcount
      </Overlay.Header>
      <Overlay.Content>
        <form onSubmit={handleSubmit}>
          <Typography variant="body-md" mb={2}>
            Select the number of guests below. We'll handle the rest!
          </Typography>
          <TextField
            value={String(headcount)}
            onChange={(e) => setHeadcount(Number(e.target.value))}
            placeholder={String(catering.headcount)}
            fullWidth
            InputProps={{
              endAdornment: <InputAdornment position="start">
                <Typography variant="label-md">People</Typography>
              </InputAdornment>,
              type: 'number',
            }}
          />
        </form>

      </Overlay.Content>
      <Overlay.Actions>
        <Button
          variant="secondary"
          onClick={onClose}
          fullWidth={isMobile}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          fullWidth={isMobile}
          disabled={isDisabled}
          onClick={handleSubmit}
        >
          Select
        </Button>
      </Overlay.Actions>
    </Overlay>
  );
}
export default HeadcountOverlay;
